import { Auth } from 'aws-amplify'
import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3'

const BUCKET = process.env.REACT_APP_AWS_DOCUMENT_BUCKET
const REGION = process.env.REACT_APP_AWS_REGION

// Must match Storage.AWSS3.customPrefix.public configured in App.js
const PUBLIC_PREFIX = 'uploads/'

// Bypasses aws-amplify's Storage.put: for files over 5MB it switches to a
// multipart upload whose CompleteMultipartUploadCommand comes back as
// MalformedXML on this aws-amplify/@aws-sdk/client-s3 version. A plain
// PutObjectCommand sidesteps that broken code path entirely.
export const putObjectToS3 = async ({ key, body, contentType, metadata }) => {
	const { accessKeyId, secretAccessKey, sessionToken } =
		await Auth.currentCredentials()

	const client = new S3Client({
		region: REGION,
		credentials: { accessKeyId, secretAccessKey, sessionToken },
	})

	await client.send(
		new PutObjectCommand({
			Bucket: BUCKET,
			Key: `${PUBLIC_PREFIX}${key}`,
			Body: body,
			ContentType: contentType,
			Metadata: metadata,
		})
	)

	return { key }
}
